export const ROLE = {
  superAdmin: '0',
  user: '1',
};
